export default "__VITE_ASSET__BcIM38IB__"